import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "회사 소개", path: "/about" },
    { name: "브랜드", path: "/brand" },
    { name: "기술", path: "/technology" },
    { name: "공동체", path: "/community" },
    { name: "협력", path: "/partnership" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-[#FFFEF9] shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/c154a28dc0dac546d2890f3443561ccc.jpg"
              alt="Daygreen"
              className="h-10 w-10 object-contain"
            />
            <span
              className={`text-2xl font-bold transition-colors ${
                isScrolled ? "text-[#2C3E2E]" : "text-white"
              }`}
            >
              Daygreen
            </span>
          </Link>

          <div className="flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? isScrolled
                      ? "text-[#7A9B76]"
                      : "text-white"
                    : isScrolled
                    ? "text-[#2C3E2E] hover:text-[#7A9B76]"
                    : "text-white/90 hover:text-white"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}